import * as React from "react";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";

import MenuItem from "ui/MenuItem";

import useCheckPermissions from "hooks/useCheckPermissions";

const NavRailMenuItem = (props) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const checkPermission = useCheckPermissions();
  const { Icon, title, link, className, permission } = props;
  const selected = pathname?.startsWith(link);

  if (!checkPermission(permission)) return null;

  function onClick() {
    navigate(link);
  }

  return (
    <MenuItem
      variant="NavRail"
      title={title}
      onClick={onClick}
      className={classNames("nav-rail-menu-item", className)}
      selected={selected}
    >
      {Icon && (
        <span
          className={classNames("nav-rail-menu-item-icon", {
            selected: selected,
          })}
        >
          <Icon />
        </span>
      )}
      {title}
    </MenuItem>
  );
};

NavRailMenuItem.propTypes = {
  Icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  className: PropTypes.string,
  permission: PropTypes.string,
};

export default NavRailMenuItem;
